import { EMAIL_REGEX } from 'constants/AppConstants';
import {
  ORDER_PREFERENCES_PRODUCT_ADDONS_ROUTE,
  // ORDER_PREFERENCES_TRUDESIGN_SETTINGS_ROUTE,
  ORDER_PREFERENCES_CUSTOM_COVER_PAGE_ROUTE,
  ORDER_PREFERENCES_PRODUCT_SUBSTITUTIONS_ROUTE,
  ORDER_PREFERENCES_PRODUCT_SELECTION_ROUTE,
} from 'constants/RouteConstants';
import i18n from 'i18n';

const { t } = i18n;

export const getTabListItems = () => [
  { label: t('order_preferences__product_selection_and_settings'), id: 0, url: ORDER_PREFERENCES_PRODUCT_SELECTION_ROUTE },
  { label: t('order_preferences__product_substitutions'), id: 1, url: ORDER_PREFERENCES_PRODUCT_SUBSTITUTIONS_ROUTE },
  { label: t('order_preferences__product_addons'), id: 2, url: ORDER_PREFERENCES_PRODUCT_ADDONS_ROUTE },
  { label: t('order_preferences__custom_cover_page'), id: 3, url: ORDER_PREFERENCES_CUSTOM_COVER_PAGE_ROUTE },
  // { label: t('order_preferences__truedesign_settings'), id: 4, url: ORDER_PREFERENCES_TRUDESIGN_SETTINGS_ROUTE },
];

export const getPropertyValues = (orderPreferences, inputFieldValues, propertyName) => (
  inputFieldValues?.[propertyName] || orderPreferences?.[propertyName] || {}
);

export const getReportFormatOptions = (subKey, orderPreferences, inputFieldValues) => [
  {
    id: `reportOptionsDeliverableDxf${subKey}CB`,
    checked: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsDeliverableDxf')[subKey],
    disabled: !orderPreferences.reportOptionsDeliverableDxf.canEdit,
    key: 'reportOptionsDeliverableDxf',
    subkey: subKey,
    text: 'order_preferences__product_addons_DXF',
  },
  {
    id: `reportOptionsDeliverableRxf${subKey}CB`,
    checked: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsDeliverableRxf')[subKey],
    disabled: !orderPreferences.reportOptionsDeliverableRxf.canEdit,
    key: 'reportOptionsDeliverableRxf',
    subkey: subKey,
    text: 'order_preferences__product_addons_RXF',
  },
  {
    id: `reportOptionsDeliverableXml${subKey}CB`,
    checked: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsDeliverableXml')[subKey],
    disabled: !orderPreferences.reportOptionsDeliverableXml.canEdit,
    key: 'reportOptionsDeliverableXml',
    subkey: subKey,
    text: 'order_preferences__product_addons_XML',
  },
];

const orderPreferencesFieldValidators = {
  emailCC: (emailCC) => {
    // #genai: Sonar S6582 flagged the `a?.value && a?.value.split(...)` chain here, but a plain
    // `emailCC?.value?.split(...)` is NOT equivalent: when `value` is an empty string (falsy but
    // not nullish), the original short-circuits to `[]` via the trailing `|| []`, whereas optional
    // chaining alone would call `''.split(';')` and produce `['']`, changing validation behavior.
    // This ternary keeps the exact original truthy-guard semantics while removing the flagged `&&` chain.
    const emailIDs = emailCC?.value
      ? emailCC.value.split(';').map((value) => value.trim())
      : [];
    const hasInvalidEmailIDs = emailIDs.some((value) => !EMAIL_REGEX.test(value));
    return hasInvalidEmailIDs && t('finalize_order__invalid_email_address');
  },
};

/**
 * Validates the input field values for order preferences.
 *
 * @param {Object} inputFieldValues - The input field values to be validated.
 * @returns {Object} - The errors object containing any validation errors.
 */
export const validateOrderPreferenceInputs = (inputFieldValues) => (
  Object.keys(orderPreferencesFieldValidators)
    .reduce(
      (errors, key) => {
        const validatorFunction = orderPreferencesFieldValidators[key];
        const error = (typeof validatorFunction === 'function') && validatorFunction(inputFieldValues[key]);

        if (error) return { ...errors, [key]: error };
        return errors;
      },
      {},
    )
);
